import React from 'react';
import { connect } from 'react-redux';
import GithubButton from '../components/GithubButton/GithubButton';
import * as actions from '../../redux/user/actions.user';
import showOauthDialog from '../../services/mini/showOauthDialog';
import asyncDispatch from '../../services/mini/asyncDispatch';

class ConnectGithubAccountForm extends React.Component {

    connectAccount = () => {
        const { getGithubOauthUrl, onBeforeClick } = this.props;
        if (onBeforeClick) {
            onBeforeClick();
        }

        getGithubOauthUrl({ action: 'assign', withUserId: true }).then((authUrl) => {
            showOauthDialog(authUrl);
        });
    }

    render() {
        const { mode, githubScope, title } = this.props;

        const label = title ?
            title :
            (githubScope ? 'Re-connect Github account' : 'Connect Github account');

        return (
            <div className="connect-github-account-form" style={{ display: mode === 'link' ? 'inline-block' : 'block' }}>
                {mode === 'link' ?
                    <span><a className="connect-github-account-form_link" onClick={this.connectAccount}>{label}</a></span> :
                    <GithubButton title={label} onClickAction={this.connectAccount} />
                }
            </div>
        );
    }
}


function mapStateToProps({ user }) {
    return {
        githubLogin: user.githubLogin,
        githubScope: user.githubScope,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getGithubOauthUrl: (param) => asyncDispatch(actions.getGithubOauthUrl, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConnectGithubAccountForm);

